import React, { useEffect } from "react";
import SideMenuTabs from "./SideMenuTabs.js";

function MobileMenu({ handleMobileMenu }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") handleMobileMenu();
    };
    document.addEventListener("keydown", onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previous;
    };
  }, [handleMobileMenu]);

  return (
    <div className="sm:hidden">
      <button
        type="button"
        aria-label="Close menu"
        className="fixed inset-0 bg-gx-navy/50 z-overlay"
        onClick={handleMobileMenu}
      />
      <div className="fixed top-16 left-0 bottom-0 w-[min(20rem,88vw)] bg-gx-navy z-overlay overflow-y-auto custom-scrollbar">
        <SideMenuTabs isSidebarOpen={true} />
      </div>
    </div>
  );
}

export default MobileMenu;
